//This will be the dropdown item you see on the schedule page.  You can choose from
//either a league or a team to view a desired schedule
import React, { useState, useEffect } from 'react'
import Card from './Card'
import { useNavigate, useParams } from 'react-router-dom'

const FilterByTeam = (props) => {
	const [isLoading, setIsLoading] = useState(false)
	const [loadedTeams, setLoadedTeams] = useState()
	const [leagueName, setLeagueName] = useState()
	const [session, setSession] = useState()
	const [year, setYear] = useState()
	const [error, setError] = useState()

	const leagueId = useParams().leagueId || props.leagueId

	let selectedTeam

	console.log('inside FilterByTeam for leagueId' + leagueId)
	//
	//
	//
	//Make backend call to getTeamsInLeagueByLeagueId
	useEffect(() => {
		const getTeamsInLeague = async () => {
			/* console.log(
				'inside FilterByTeam --> making backend call to getTeamsInLeagueByLeagueId'
			) */
			setIsLoading(true)
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/admin/allTeams/${leagueId}`
					//process.env.REACT_APP_BACKEND_URL + '/league/allCurrentTeams'
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				//console.log('listOfTeams: ' + JSON.stringify(responseData))
				/* console.log(
					'setLoadedTeams: ' + JSON.stringify(responseData.listOfTeams)
				) */

				setLoadedTeams(responseData.listOfTeams)
				setLeagueName(responseData.leagueName)
				setSession(responseData.session)
				setYear(responseData.year)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		getTeamsInLeague()
	}, [setLoadedTeams])
	//
	//
	//
	//
	//
	let teamArray

	if (loadedTeams && !isLoading) {
		teamArray = []
		loadedTeams.forEach((team) => {
			teamArray.push(team)
		})
		teamArray.sort((a, b) => a.divisionName.localeCompare(b.divisionName))
	}

	//console.log('teamArray: ' + JSON.stringify(teamArray))

	let navigate = useNavigate()

	//For handling a search by TEAM request
	const handleChange2 = (e) => {
		e.preventDefault()
		const selectedValue = e.target.value
		//console.log('selectedValue: ' + selectedValue)
		selectedTeam = teamArray[selectedValue]
		console.log('selectedTeam: ' + JSON.stringify(selectedTeam))
		const teamId = selectedTeam._id
		const teamName = selectedTeam.teamName
		/* < - - navigate to TeamSchedule.js - - >*/
		navigate(`/league/schedule/${leagueName}/${teamId}/${year}/${teamName}`)
	}

	return (
		<React.Fragment>
			<div className='searchbyleagueorvenue'>
				<div className='row'>
					<div className='LTVinstructions'>Filter by Team: </div>
				</div>
				{!isLoading && loadedTeams && (
					<div className='row'>
						<div className='col'></div>
						<div className='col-sm'>
							<form className='dropdownForm' style={{ textAlign: 'center' }}>
								<select
									className='scheduleselectornonadmin'
									onChange={handleChange2}
								>
									<option defaultValue>Select a Team....</option>
									{teamArray.map((team, i) => (
										<option value={i} key={i}>
											{team.divisionName + ' >>> ' + team.teamName}
										</option>
									))}
								</select>
							</form>
						</div>
						<div className='col'></div>
					</div>
				)}
			</div>
		</React.Fragment>
	)
}

export default FilterByTeam
